import { Backdrop, CircularProgress } from "@mui/material";
import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useMemo, useState } from "react";
import { QuestionCircleFill, X } from "react-bootstrap-icons";
import API from "../../API/newIndex";
import { ChangePathContext } from "../../App";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { parentNavigate } from "../../controllers/ParentNavigate";
import SourceCode from "../../controllers/SourceCode";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import Notification from "../Notification";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
  RichTextEditor,
  SelectComponent,
} from "@shopeasy-dashboard-ui/ui-library";

function AddFaq() {
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [warn, setwarn] = useState(false);
  const [FaqData, setFaqData] = useState({
    question: "",
    answer: "",
    faq_type: "",
  });
  const HandleInput = (e) => {
    setFaqData({ ...FaqData, [e.target.name]: e.target.value });
  };
  const [answer, setAnswer] = useState("");
  const { question } = FaqData;
  const [faqtype, setFaqtype] = useState("pages");
  const [faqpages, setFaqPages] = useState([]);
  const [faqLoading, setFaqLoading] = useState(false);
  const [faqSelected, setFaqSelected] = useState([]);

  const removeSelectdPath = (e, link) => {
    e.preventDefault();
    const filterSelectedPath = faqSelected?.filter((x) => x?.link !== link);
    setFaqSelected(filterSelectedPath);
  };

  const getFaqPages = async (type) => {
    try {
      setFaqLoading(true);
      const apiCall = await API({
        url: "/admin/faq/GetFaqLinkList",
        method: "get",
        params: { type },
      });
      return apiCall?.data?.templates || [];
    } catch (error) {
      console.error("FAQ page error:", error);
      return [];
    } finally {
      setFaqLoading(false);
    }
  };

  useEffect(() => {
    setFaqSelected([]);
    const fetchFaqPages = async () => {
      const data = await getFaqPages(faqtype);
      setFaqPages(data);
    };
    if (faqtype) fetchFaqPages();
  }, [faqtype]);

  const [AiLoader, setAiloader] = useState(false);

  const generateAnswer = async () => {
    setAiloader(true);
    try {
      const payload = {
        question: question,
      };
      let ApiCall = await API({
        url: "/admin/ai/answer_from_questionFAQ",
        method: "post",
        data: payload,
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setAnswer(result?.data);
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Hit_chatgpt_limit"));
        setSeverity("warning");
      } else {
        setIsNotification(true);
        setNotificationMsg(error?.response?.data?.message);
        setSeverity("error");
      }
    } finally {
      setAiloader(false);
    }
  };

  const [err, setErr] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const isAnswerEmpty = useMemo(() => {
    if (!answer) return true;

    // Remove HTML tags
    const text = answer
      .replace(/<style[^>]*>.*?<\/style>/gi, "")
      .replace(/<script[^>]*>.*?<\/script>/gi, "")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  }, [answer]);

  const HandleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      let body;
      body = {
        question,
        answer,
        faq_type: faqtype,
        path: faqSelected.map((x) => ({
          link: x.link,
          name: x.name,
        })),
      };

      const payload = body;
      await API({ url: "/admin/faq/addFAQ", method: "post", data: payload });
      setSaveChanges({
        isUnsaveChanges: false,
        showChangesPopup: false,
        backLink: "/faqs",
        title: "add faqs",
      });
      parentNavigate("/faqs");
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const handleQuillChange = (value) => {
    setAnswer(value);
  };
  const [html, setHtml] = useState({ htmlPP: false, code: "" });
  const saveHTML = (value) => {
    setHtml({ ...html, htmlPP: false });
    setAnswer(value);
  };
  const closeCode = () => {
    setHtml({ ...html, htmlPP: false });
  };

  useEffect(() => {
    if (
      faqSelected?.length > 0 ||
      faqtype !== "pages" ||
      answer?.length > 0 ||
      question?.length > 0
    ) {
      setSaveChanges({
        backLink: "/faqs",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "add faqs",
      });
    } else {
      setSaveChanges({
        backLink: "/faqs",
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "add faqs",
      });
    }
  }, [faqSelected, faqtype, answer, question]);

  const checkChanges = () => {
    if (
      faqSelected?.length > 0 ||
      faqtype !== "pages" ||
      answer?.length > 0 ||
      question?.length > 0
    ) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: "/faqs",
        title: "add faqs",
      });
    } else {
      parentNavigate("/faqs");
    }
  };

  const isSubmitDisabled =
    question === "" ||
    isAnswerEmpty === true ||
    (faqtype !== "" && !faqSelected?.length);

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}

      {AiLoader && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={AiLoader}
          className="flex flex-col"
        >
          <CircularProgress color="inherit" />
          <p>{t("lang_Please_Wait")}</p>
        </Backdrop>
      )}
      <div className="h-auto overflow-y-auto pb-[65px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_faqs"), path: "/faqs" },
                    { name: t("lang_Add_New_FAQs"), path: "/faqs/add" },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Add_New_FAQs")}
                  </h4>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://docs.shopeasy.ai/faqs"
                    className="how-it-works !m-0"
                  >
                    <QuestionCircleFill className="me-1.5" />
                    {t("lang_how_to_use")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
            <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} className="space-y-4">
              <DetailsComponent
                open={true}
                hasHr={false}
                showChevron={false}
                className="!pt-5 sm:!pt-[25px]"
              >
                <div className="mb-4">
                  <InputComponent
                    id="question"
                    name="question"
                    label={t("lang_Question")}
                    required={true}
                    value={question}
                    onChange={(e) => {
                      HandleInput(e);
                      setwarn(false);
                    }}
                    placeholder="Write your faq question"
                    error={
                      err && question.length === 0
                        ? t("lang_Please_Enter_Question")
                        : ""
                    }
                    helpText={
                      warn
                        ? t("lang_Please_Enter_Question_To_Generate_Answer")
                        : ""
                    }
                  />
                </div>
                <div>
                  <div className="flex space-x-3 justify-between items-center mb-1">
                    <label htmlFor="Answer">
                      <p className="text-[13px] font-medium text-[var(--primary-text-color)] m-0">
                        {t("lang_Answer")}
                        <span className="text-red-500 ms-1">*</span>
                      </p>
                    </label>
                    <div className="flex items-center">
                      <span
                        className="inline-flex items-center cursor-pointer hover:underline text-[13px] rounded-[6px] transition duration-300 px-1"
                        onClick={() => {
                          if (question === "") {
                            setwarn(true);
                          } else {
                            generateAnswer();
                            setwarn(false);
                          }
                        }}
                      >
                        <BardSvg /> {t("lang_Get_Answer")}
                      </span>
                    </div>
                  </div>
                  <RichTextEditor
                    htmlData={answer}
                    setHtmlData={handleQuillChange}
                    uplaodImageFile={uploadTextEditorImage}
                  />
                  {err && isAnswerEmpty ? (
                    <p className="text-red-500 text-xs mt-1">{t("lang_Please_Enter_Answer")}</p>
                  ) : null}
                </div>
                <div className="w-full mt-4">
                  <SelectComponent
                    id="faqtype"
                    name="faqtype"
                    label={t("lang_FAQ_Type")}
                    required={true}
                    value={faqtype}
                    onChange={(e) => setFaqtype(e.target.value)}
                    options={[
                      { value: "pages", label: t("lang_pages") },
                      { value: "product", label: t("lang_Product") },
                      { value: "category", label: t("lang_category") },
                      { value: "blog", label: t("lang_blog") },
                    ]}
                  />
                </div>
                {faqpages?.length > 0 && (
                  <div className="mt-4">
                    <SelectComponent
                      id="faqPath"
                      name="faqPath"
                      label={t("lang_path")}
                      required={true}
                      placeholder="Select Path"
                      loading={faqLoading}
                      value=""
                      onChange={(e) => {
                        const selectedLink = e.target.value;
                        const foundItem = faqpages.find(
                          (x) => x.link === selectedLink || x.value === selectedLink,
                        );
                        if (foundItem) {
                          setFaqSelected((prev) => {
                            const alreadyExist = prev.some((item) => item.link === foundItem.link);
                            if (alreadyExist) return prev;
                            return [...prev, foundItem];
                          });
                        }
                      }}
                      options={faqpages?.map((item) => ({
                        value: item.link,
                        label: item.name ? `${item.name} (${item.link})` : item.link,
                      }))}
                    />

                    <div className="flex flex-wrap mt-2">
                      {faqSelected?.map((elem, index) => {
                        return (
                          <div
                            key={index}
                            className="primary-bg-color flex items-center me-2 mb-2 min-w-[50px] text-xs text-left px-3 capitalize py-1.5 rounded-[6px]"
                          >
                            <span className="table-text">{elem?.name}</span>
                            <X
                              className="h-[14px] text-red-500 hover:text-red-700 min-w-[14px] max-w-[14px] ms-1 cursor-pointer"
                              onClick={(e) => removeSelectdPath(e, elem?.link)}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </DetailsComponent>
            </form>
          </div>
        </div>
        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-3 left-0">
          <div className="w-[90%] flex items-center justify-between lg:w-[70%] xl:w-[58%] mx-auto">
            <ButtonComponent
              variant="link"
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              icon={<ArrowLeft className="w-3 mr-1" />}
              className="text-[var(--table-text-color)]"
            >
              {t("lang_Go_To_FAQs")}
            </ButtonComponent>
            <div>
              <ButtonComponent
                variant="primary"
                disabled={isSubmitDisabled}
                loading={btnLoading}
                onClick={(e) => HandleSubmit(e)}
              >
                {t("lang_Add_New_FAQ")}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
      {html?.htmlPP && (
        <SourceCode
          open={html?.htmlPP}
          htmlCode={html?.code}
          closeCode={closeCode}
          saveHTML={saveHTML}
        />
      )}
    </>
  );
}

export default AddFaq;
